import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { AllocationDataImpl } from "../model/impl/AllocationDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class AllocationDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: AllocationDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationId != null) {
      this.baseEncoder.writeStartFid(981, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(981),
        false,
        encodable.allocationId,
        streamout,
      );
      this.baseEncoder.writeEndFid(981, streamout);
    }
    /*Object encoding*/
    if (encodable.riskId != null) {
      this.baseEncoder.writeStartFid(982, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(982),
        false,
        encodable.riskId,
        streamout,
      );
      this.baseEncoder.writeEndFid(982, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationReference != null) {
      this.baseEncoder.writeStartFid(983, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(983),
        false,
        encodable.allocationReference,
        streamout,
      );
      this.baseEncoder.writeEndFid(983, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationType != null) {
      this.baseEncoder.writeStartFid(984, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(984),
        false,
        encodable.allocationType,
        streamout,
      );
      this.baseEncoder.writeEndFid(984, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationIntent != null) {
      this.baseEncoder.writeStartFid(985, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(985),
        false,
        encodable.allocationIntent,
        streamout,
      );
      this.baseEncoder.writeEndFid(985, streamout);
    }
    /*Object encoding*/
    if (encodable.accountCode != null) {
      this.baseEncoder.writeStartFid(986, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(986),
        false,
        encodable.accountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(986, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCcy != null) {
      this.baseEncoder.writeStartFid(987, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(987),
        false,
        encodable.baseCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(987, streamout);
    }
    /*Object encoding*/
    if (encodable.nonbaseCcy != null) {
      this.baseEncoder.writeStartFid(988, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(988),
        false,
        encodable.nonbaseCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(988, streamout);
    }
    /*Object encoding*/
    if (encodable.fixedCcy != null) {
      this.baseEncoder.writeStartFid(989, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(989),
        false,
        encodable.fixedCcy,
        streamout,
      );
      this.baseEncoder.writeEndFid(989, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationProductCd != null) {
      this.baseEncoder.writeStartFid(990, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(990),
        false,
        encodable.allocationProductCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(990, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationQty != null) {
      this.baseEncoder.writeStartFid(991, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(991),
        false,
        encodable.allocationQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(991, streamout);
    }
    /*Object encoding*/
    if (encodable.settleQty != null) {
      this.baseEncoder.writeStartFid(992, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(992),
        false,
        encodable.settleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(992, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesQty != null) {
      this.baseEncoder.writeStartFid(993, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(993),
        false,
        encodable.leavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(993, streamout);
    }
    /*Object encoding*/
    if (encodable.leavesSettleQty != null) {
      this.baseEncoder.writeStartFid(994, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(994),
        false,
        encodable.leavesSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(994, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivQty != null) {
      this.baseEncoder.writeStartFid(995, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(995),
        false,
        encodable.usdEquivQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(995, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivLeavesQty != null) {
      this.baseEncoder.writeStartFid(996, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(996),
        false,
        encodable.usdEquivLeavesQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(996, streamout);
    }
    /*Object encoding*/
    if (encodable.settleTenor != null) {
      this.baseEncoder.writeStartFid(997, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(997),
        false,
        encodable.settleTenor,
        streamout,
      );
      this.baseEncoder.writeEndFid(997, streamout);
    }
    /*Object encoding*/
    if (encodable.settleDate != null) {
      this.baseEncoder.writeStartFid(998, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(998),
        false,
        encodable.settleDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(998, streamout);
    }
    /*Object encoding*/
    if (encodable.fillDetails != null) {
      this.baseEncoder.writeStartFid(999, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(999),
        true,
        encodable.fillDetails,
        streamout,
      );
      this.baseEncoder.writeEndFid(999, streamout);
    }
    /*Object encoding*/
    if (encodable.markupQty != null) {
      this.baseEncoder.writeStartFid(1000, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1000),
        false,
        encodable.markupQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1000, streamout);
    }
    /*Object encoding*/
    if (encodable.markupType != null) {
      this.baseEncoder.writeStartFid(1001, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1001),
        false,
        encodable.markupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(1001, streamout);
    }
    /*Object encoding*/
    if (encodable.salesMarkup != null) {
      this.baseEncoder.writeStartFid(1002, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1002),
        false,
        encodable.salesMarkup,
        streamout,
      );
      this.baseEncoder.writeEndFid(1002, streamout);
    }
    /*Object encoding*/
    if (encodable.deskId != null) {
      this.baseEncoder.writeStartFid(1003, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1003),
        false,
        encodable.deskId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1003, streamout);
    }
    /*Object encoding*/
    if (encodable.secondaryDeskId != null) {
      this.baseEncoder.writeStartFid(1004, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1004),
        false,
        encodable.secondaryDeskId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1004, streamout);
    }
    /*Object encoding*/
    if (encodable.componentAllocations != null) {
      this.baseEncoder.writeStartFid(1005, streamout);
      this.baseEncoder.writeObject(
        true,
        AllocationDataImplEncoder.fidTypeMap.get(1005),
        false,
        encodable.componentAllocations,
        streamout,
      );
      this.baseEncoder.writeEndFid(1005, streamout);
    }
    /*Object encoding*/
    if (encodable.accountName != null) {
      this.baseEncoder.writeStartFid(1006, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1006),
        false,
        encodable.accountName,
        streamout,
      );
      this.baseEncoder.writeEndFid(1006, streamout);
    }
    /*Object encoding*/
    if (encodable.usdEquivExecutedQty != null) {
      this.baseEncoder.writeStartFid(1007, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1007),
        false,
        encodable.usdEquivExecutedQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1007, streamout);
    }
    /*Object encoding*/
    if (encodable.alternateAccountCode != null) {
      this.baseEncoder.writeStartFid(1008, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1008),
        false,
        encodable.alternateAccountCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(1008, streamout);
    }
    /*Object encoding*/
    if (encodable.oboAccount != null) {
      this.baseEncoder.writeStartFid(1009, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1009),
        false,
        encodable.oboAccount,
        streamout,
      );
      this.baseEncoder.writeEndFid(1009, streamout);
    }
    /*Object encoding*/
    if (encodable.creditRejectCd != null) {
      this.baseEncoder.writeStartFid(1010, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1010),
        false,
        encodable.creditRejectCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(1010, streamout);
    }
    /*Object encoding*/
    if (encodable.allocationRef != null) {
      this.baseEncoder.writeStartFid(1011, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1011),
        false,
        encodable.allocationRef,
        streamout,
      );
      this.baseEncoder.writeEndFid(1011, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdMarkupValue != null) {
      this.baseEncoder.writeStartFid(1012, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1012),
        false,
        encodable.fwdMarkupValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(1012, streamout);
    }
    /*Object encoding*/
    if (encodable.spotMarkupType != null) {
      this.baseEncoder.writeStartFid(1013, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1013),
        false,
        encodable.spotMarkupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(1013, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdMarkupType != null) {
      this.baseEncoder.writeStartFid(1014, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1014),
        false,
        encodable.fwdMarkupType,
        streamout,
      );
      this.baseEncoder.writeEndFid(1014, streamout);
    }
    /*Object encoding*/
    if (encodable.spotMarkupValue != null) {
      this.baseEncoder.writeStartFid(1015, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1015),
        false,
        encodable.spotMarkupValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(1015, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFwdPoints != null) {
      this.baseEncoder.writeStartFid(1016, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1016),
        false,
        encodable.reqFwdPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(1016, streamout);
    }
    /*Object encoding*/
    if (encodable.spotAllocationQty != null) {
      this.baseEncoder.writeStartFid(1017, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1017),
        false,
        encodable.spotAllocationQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1017, streamout);
    }
    /*Object encoding*/
    if (encodable.spotSettleQty != null) {
      this.baseEncoder.writeStartFid(1018, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1018),
        false,
        encodable.spotSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1018, streamout);
    }
    /*Object encoding*/
    if (encodable.npvAllocationQty != null) {
      this.baseEncoder.writeStartFid(1019, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1019),
        false,
        encodable.npvAllocationQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1019, streamout);
    }
    /*Object encoding*/
    if (encodable.npvSettleQty != null) {
      this.baseEncoder.writeStartFid(1020, streamout);
      this.baseEncoder.writeObject(
        false,
        AllocationDataImplEncoder.fidTypeMap.get(1020),
        false,
        encodable.npvSettleQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(1020, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,AllocationDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [981, "java.lang.Long"],
    [982, "java.lang.Long"],
    [983, "java.lang.String"],
    [984, "com.bcdfx.model.common.api.enums.AllocationType"],
    [985, "com.bcdfx.model.OrderIntent"],
    [986, "java.lang.String"],
    [987, "java.lang.String"],
    [988, "java.lang.String"],
    [989, "java.lang.String"],
    [990, "com.bcdfx.model.Product"],
    [991, "java.math.BigDecimal"],
    [992, "java.math.BigDecimal"],
    [993, "java.math.BigDecimal"],
    [994, "java.math.BigDecimal"],
    [995, "java.math.BigDecimal"],
    [996, "java.math.BigDecimal"],
    [997, "com.bcdfx.model.Tenor"],
    [998, "java.util.Date"],
    [999, "com.bcdfx.model.event.lifecycle.fx.LastFillDetails"],
    [1000, "java.math.BigDecimal"],
    [1001, "com.bcdfx.model.MarkUpType"],
    [1002, "java.math.BigDecimal"],
    [1003, "java.lang.Long"],
    [1004, "java.lang.Long"],
    [1005, "com.bcdfx.model.event.lifecycle.fx.AllocationData"],
    [1006, "java.lang.String"],
    [1007, "java.math.BigDecimal"],
    [1008, "java.lang.String"],
    [1009, "java.lang.String"],
    [1010, "java.lang.Long"],
    [1011, "java.lang.String"],
    [1012, "java.math.BigDecimal"],
    [1013, "com.bcdfx.model.MarkUpType"],
    [1014, "com.bcdfx.model.MarkUpType"],
    [1015, "java.math.BigDecimal"],
    [1016, "java.math.BigDecimal"],
    [1017, "java.math.BigDecimal"],
    [1018, "java.math.BigDecimal"],
    [1019, "java.math.BigDecimal"],
    [1020, "java.math.BigDecimal"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: AllocationDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 981: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(981),
            streamin,
          );
          encodable.allocationId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 982: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(982),
            streamin,
          );
          encodable.riskId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 983: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(983),
            streamin,
          );
          encodable.allocationReference = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 984: {
          /*Object encoding*/
          let val: CubiqTS.AllocationType = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(984),
            streamin,
          );
          encodable.allocationType = <CubiqTS.AllocationType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 985: {
          /*Object encoding*/
          let val: CubiqTS.OrderIntent = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(985),
            streamin,
          );
          encodable.allocationIntent = <CubiqTS.OrderIntent>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 986: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(986),
            streamin,
          );
          encodable.accountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 987: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(987),
            streamin,
          );
          encodable.baseCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 988: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(988),
            streamin,
          );
          encodable.nonbaseCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 989: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(989),
            streamin,
          );
          encodable.fixedCcy = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 990: {
          /*Object encoding*/
          let val: CubiqTS.Product = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(990),
            streamin,
          );
          encodable.allocationProductCd = <CubiqTS.Product>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 991: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(991),
            streamin,
          );
          encodable.allocationQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 992: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(992),
            streamin,
          );
          encodable.settleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 993: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(993),
            streamin,
          );
          encodable.leavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 994: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(994),
            streamin,
          );
          encodable.leavesSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 995: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(995),
            streamin,
          );
          encodable.usdEquivQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 996: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(996),
            streamin,
          );
          encodable.usdEquivLeavesQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 997: {
          /*Object encoding*/
          let val: CubiqTS.Tenor = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(997),
            streamin,
          );
          encodable.settleTenor = <CubiqTS.Tenor>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 998: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(998),
            streamin,
          );
          encodable.settleDate = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 999: {
          /*Object encoding*/
          let val: CubiqTS.LastFillDetails = this.baseEncoder.readObject(
            true,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(999),
            streamin,
          );
          encodable.fillDetails = <CubiqTS.LastFillDetails>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1000: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1000),
            streamin,
          );
          encodable.markupQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1001: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1001),
            streamin,
          );
          encodable.markupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1002: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1002),
            streamin,
          );
          encodable.salesMarkup = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1003: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1003),
            streamin,
          );
          encodable.deskId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1004: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1004),
            streamin,
          );
          encodable.secondaryDeskId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1005: {
          /*Object encoding*/
          let val: Array<CubiqTS.AllocationData> = this.baseEncoder.readObject(
            false,
            true,
            AllocationDataImplEncoder.fidTypeMap.get(1005),
            streamin,
          );
          encodable.componentAllocations = <Array<CubiqTS.AllocationData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1006: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1006),
            streamin,
          );
          encodable.accountName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1007: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1007),
            streamin,
          );
          encodable.usdEquivExecutedQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1008: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1008),
            streamin,
          );
          encodable.alternateAccountCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1009: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1009),
            streamin,
          );
          encodable.oboAccount = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1010: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1010),
            streamin,
          );
          encodable.creditRejectCd = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1011: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1011),
            streamin,
          );
          encodable.allocationRef = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1012: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1012),
            streamin,
          );
          encodable.fwdMarkupValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1013: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1013),
            streamin,
          );
          encodable.spotMarkupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1014: {
          /*Object encoding*/
          let val: CubiqTS.MarkUpType = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1014),
            streamin,
          );
          encodable.fwdMarkupType = <CubiqTS.MarkUpType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1015: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1015),
            streamin,
          );
          encodable.spotMarkupValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1016: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1016),
            streamin,
          );
          encodable.reqFwdPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1017: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1017),
            streamin,
          );
          encodable.spotAllocationQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1018: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1018),
            streamin,
          );
          encodable.spotSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1019: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1019),
            streamin,
          );
          encodable.npvAllocationQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 1020: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            AllocationDataImplEncoder.fidTypeMap.get(1020),
            streamin,
          );
          encodable.npvSettleQty = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,AllocationDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return AllocationDataImplEncoder.fidTypeMap.has(fid);
  }
}
